import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
	buttonIcon: {
		marginRight: '5px',
	},
	button: {
		marginTop: '10px',
	},
	select: {
		marginTop: '20px',
	},
	icon: {
		width: 24,
		height: 24,
	},
}));

export default useStyles;
